import { Modal } from "react-bootstrap";
import ModalHead from "../../../../common/ui/ModalHead";
import ErrorAlert from "../../../../common/ui/ErrorAlert";
import VoucherList from "./VoucherList";

export default function VouchersModalPage(props) {
    const formData = props.loyaltyMember.VoucherModalPage;
    let voucherIssueIdInCart = props.loyaltyMember.VoucherDetails.VoucherIssueId;

    return (
        <>
            <ModalHead title={`Hi, ${props.loyaltyMember.MenuNav.LoyaltyMemberButtonValue}`}
                       onClose={props.handleClickCloseLoyaltyModal} />
            <Modal.Body className="wo-loy__body">
                {/* Hidden when there is no card number — otherwise the card
                    renders as a bare coloured bar with a label and nothing in it. */}
                {props.loyaltyMember.MenuNav.CardNumber &&
                    <div className="wo-loy__card">
                        <span className="wo-loy__cardLabel">Membership</span>
                        <span className="wo-loy__cardNum">{props.loyaltyMember.MenuNav.CardNumber}</span>
                    </div>}

                <div className="wo-loy__listHead">Available rewards</div>

                <div className="wo-vou__list">
                    { formData.ShowVouchersLoading ?
                        <VoucherLoader /> :
                        <VoucherList
                            vouchers={formData.Vouchers}
                            handleSelectVoucher={props.handleSelectVoucher}
                            voucherIssueIdInCart={voucherIssueIdInCart}
                        />
                    }
                </div>

                <div className="wo-loy__form">
                    { formData.GeneralError.HasError && <ErrorAlert message={formData.GeneralError.ErrorMessage} /> }
                    <button type="button" className="wo-btn wo-btn--ghost" onClick={props.handleLoyaltyLogout} disabled={formData.GeneralError.ButtonsDisabled}>
                        Log out
                        { formData.GeneralError.ButtonsDisabled && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></> }
                    </button>
                </div>
            </Modal.Body>
        </>
    )
}

function VoucherLoader() {
    return (
        <>
            {[...Array(2)].map((item, index) =>
                <div className="wo-vou wo-vou--skel" key={index} aria-hidden="true">
                    <span className="wo-skel wo-skel--name"></span>
                    <span className="wo-skel wo-skel--line"></span>
                    <span className="wo-skel wo-skel--pill"></span>
                </div>)}
        </>
    )
}
